<div style="display: flex; height: 50px" class="main-container">
  <div style="display: flex; min-width: 310px; max-width: 310px; align-items: center;" class="case-logo-area">
    <div class="logo-wrapper">
      <img *ngIf="!isDarkMode()" alt="lexbe_logo" src="/assets/images/lexbe-logo-new-doc-viewer.svg"
        class="lexbe-toolbar-logo" />
      <img *ngIf="isDarkMode()" alt="lexbe_logo" src="/assets/images/lexbe-logo-dark-theme-new-doc-viewer.svg"
        class="lexbe-toolbar-logo" />
    </div>
    <span
      style="font-size: 14px; margin: 0px 8px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">{{caseName}}</span>
  </div>
  <div
    style="display: flex; flex-direction: row; min-width: calc(100% - 700px); justify-content: space-between; z-index: 1;">
    <div *ngIf="currentDocumentSnapshot" class="title-container" style="display: flex; font-size: 14px; margin-left: 15px; margin-right: 4px; justify-content: center; align-items: center; white-space: nowrap;
        overflow: hidden;">
      <div *ngIf="!editTitle" style="display: flex; flex-direction: row;">
        <div style="overflow: hidden; text-overflow: ellipsis; width: 100%;"
          [matTooltip]="title">
          {{title}}
        </div>
        <div *inRole="[roles.EditMetadataFeatureSet]" class="action-item" (click)="editTitle=!editTitle">
          <i class="fa-duotone fa-pen-to-square action-icon"></i>
        </div>
      </div>
      <lex-edit-input *ngIf="editTitle" [value]="title" placeholder="Document Title" (setValue)="setTitleEdit($event)" (cancelValue)="editTitle=!editTitle" style="width: 100%;"></lex-edit-input>
    </div>
    <div class="view-items" style="display: flex;justify-content: space-around; align-items: center; height: 100%;">
      <div *ngFor="let view of viewsDisplayed" class="view" (click)="setView(view.id)"
        [ngClass]="{'selected-view': view.id === (selectedView$ | async), 'disabled-view': view.isDisabled}">
        <div class="icon" [ngClass]="{'disabled-icon': view.isDisabled}">
          <i [ngClass]="view.icon"></i>
        </div>
        <div [ngClass]="{'disabled-text': view.isDisabled}" style="font-size: 14px;">{{view.name}}</div>
      </div>
      <div class="view-menu"
        style="display: flex; order: 100; justify-content: center; align-items: center; height: 100%; width: 66px; cursor: pointer;"
        matTooltip="See more" matTooltipPosition="below" [matMenuTriggerFor]="actionBarMenu"
        #viewMenuTrigger="matMenuTrigger" [ngClass]="{'selected-view': viewMenuTrigger.menuOpen === true}">
        <div class="fas fa-chevron-down tab-menu-icon"></div>
      </div>
    </div>
    <mat-menu class="doc-viewer-menu action-bar-view-menu" #actionBarMenu yPosition="below" xPosition="before">
      <menu mat-menu-item *ngFor="let view of viewsOverflow" [disabled]="view.isDisabled">
        <div (click)="setView(view.id)" style="display: flex; flex-direction: row; gap: 16px;"
          [ngClass]="{'disabled-view': view.isDisabled}">
          <div class="icon" [ngClass]="{'disabled-icon': view.isDisabled}">
            <i [ngClass]="view.icon"></i>
          </div>
          <div [ngClass]="{'disabled-text': view.isDisabled}" style="font-size: 14px;">{{view.name}}</div>
        </div>
      </menu>
    </mat-menu>
  </div>
  <div style="display: flex; justify-content: flex-end; flex-grow: 1; align-items: center; z-index: 10; width: 100%;">
    <div style="display: flex; justify-content: flex-end; width: 100%; height: 100%;">
      <div id="actions" style="display: flex; width: 100%;">
        <lex-option-button (clicked)="save()"
          [disabled]="!userConfigService.inRoles(roles.DocReviewFeatureSet, roles.EditFeatureSet) || docViewerStore?.documentCodingFormGroup?.errors?.redactForPrivilegeInvalid"
          style="width: 100%;"></lex-option-button>
        <button (click)="cancel()" class="action-button" style="margin-left: 2px;" matTooltip="Cancel">
          <div style="display: flex; align-items: center; justify-content: center;">
            <div class="fa-duotone fa-rotate-left icon"></div>
          </div>
        </button>
      </div>
      <div style="display: flex; margin-right: 12px; padding-left: 12px; border-left: #EDEDED3D 1px solid;" matTooltip="Help">
        <a [href]="(helpLink$ | async)" target="_blank"
          style="display: flex; align-items: center; text-decoration: none;">
          <i class="fa-duotone fa-square-question icon" style="display: flex; justify-content: center;"></i>
        </a>
      </div>
      <div *ngIf="mode === 'review'" class="close-button"
        style="display: flex; justify-content: center; align-items: center; width: 55px; height: 50px; font-size: 16px; color: inherit; background-color: inherit; cursor: pointer;"
        (click)="close()" matTooltip="Exit Review">
        <i class="fal fa-times"></i>
      </div>
    </div>
  </div>

</div>